export const LOW_BALANCE_THRESHOLD = 1000;

/** Pro / Enterprise (incl. the *_LEGACY_2025 tiers) are prepaid contracts, so a low balance
 *  isn't actionable. A missing tier (lookup failed) is treated as unknown, not prepaid. */
export function isPrepaidPlan(plan: string | null | undefined): boolean {
  return /^(PRO|ENTERPRISE)(_|$)/.test(plan ?? "");
}

export function planLabel(plan: string | null | undefined): string | null {
  if (!isPrepaidPlan(plan)) {
    return null;
  }
  const base = plan!.startsWith("PRO") ? "Pro" : "Enterprise";
  return plan!.includes("_LEGACY") ? `${base} (legacy)` : base;
}

export function needsAttention(org: {
  amount: number | null;
  plan?: string | null;
}): boolean {
  return (
    org.amount !== null &&
    org.amount < LOW_BALANCE_THRESHOLD &&
    !isPrepaidPlan(org.plan)
  );
}

/** Extra context so a trial/frozen/expired Pro domain isn't silently hidden by its plan. */
export function planNotes(
  org: {
    status?: string | null;
    type?: string | null;
    contractEndDate?: string | null;
  },
  now: Date = new Date()
): string[] {
  const notes: string[] = [];
  if (org.type === "TRIAL") {
    notes.push("Trial");
  }
  if (org.status && org.status !== "ACTIVE") {
    notes.push(org.status.charAt(0) + org.status.slice(1).toLowerCase());
  }
  // Compare YYYY-MM-DD strings against the local date; new Date("YYYY-MM-DD") parses as UTC.
  if (org.contractEndDate) {
    const pad = (n: number) => String(n).padStart(2, "0");
    const today = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
      now.getDate()
    )}`;
    if (org.contractEndDate.slice(0, 10) < today) {
      notes.push("Contract ended");
    }
  }
  return notes;
}
